import { SEO_TITLE_LOGIN } from 'mk/autogenerated/translations/LoginPage.17e967995c692adc9018cda08ff8d047'
import { LOGIN_FORM_NAME, LoginFormData } from 'mk2/apps/users/components/LoginForm';
import Login from 'mk2/apps/users/containers/Login/Login';
import { loginTrigger } from 'mk2/apps/users/containers/Login/Login.actions';
import { cachedInitialValues } from 'mk2/helpers/form';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import Page from 'mk2/pages/Page';
import { AppState, getRequestLastKnownUsername } from 'mk2/reducers';
import { Store } from 'mk2/store/configureStore';
import { parse } from 'query-string';
import * as React from 'react';
import { MapStateToPropsParam } from 'react-redux';
import { RouteComponentProps } from 'react-router';

interface OwnProps {}

interface StateProps {
    initialValues: LoginFormData;
}

interface DispatchProps {
    onLogin(values: LoginFormData);
}

type RouteProps = RouteComponentProps<{}>;

export type Props = OwnProps & StateProps & DispatchProps & RouteProps;

export default class LoginPage extends Page<OwnProps & RouteProps, StateProps, DispatchProps> {

    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            const { location } = ownProps;

            const query = parse(location.search);
            const username = query.username
                ? query.username.toLowerCase()
                : getRequestLastKnownUsername(state);

            return {
                initialValues: cachedInitialValues(LOGIN_FORM_NAME, {
                    username: username || '',
                    password: '',
                }, username),
            };
        };
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {
            onLogin: loginTrigger,
        };
    }

    public getMetaTitle(props: Props): string {
        return SEO_TITLE_LOGIN;
    }

    public render(props: Props): false | JSX.Element {
        return (
            <Login {...props} />
        );
    }

    public hasPageHeaderPart1(): boolean {
        return false;
    }

    public hasPageHeaderPart2(): boolean {
        return false;
    }

    public hasHeaderBackButton(props: Props): boolean {
        return false;
    }

    public registerInStore(store?: Store<AppState>) {
        return this.loadAndRegisterReducerAndSaga(
            'containers.users.login',
            null,
            import('mk2/apps/users/containers/Login/Login.sagas' /* webpackChunkName: "users.Login" */),
            store,
        );
    }
}
